interface Rolemodels2025Props {
	lang: string
}

const Rolemodels2025: React.FC<Rolemodels2025Props> = (props: Rolemodels2025Props) => {
	return (<h1>{props.lang==='nl' ? 'Rolmodellen' : 'Rolemodels'}</h1>)
}

export default Rolemodels2025